/// <amd-module name="Test/TestResultHistory/Source/HistoryViewSource" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { RepositoryTypes } from "Test/StackTraceParser/Contracts";
import * as BuildContracts from "Build/Client/Contracts/Build";
import * as VCContracts from "VC/Common/Contracts/Git";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import * as TestManagementService from "Test/Client/TestManagementServices";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IGitRestClient } from "VC/Common/RestClient/Git";
import { ITfvcRestClient } from "VC/Common/RestClient/Tfvc";

export interface IItem {
    name: string;
}

export class HistoryViewSource {

    constructor() {
        this._testRun = null;
    }

    public getTestHistory(pageContext: IVssPageContext, filter: TCMContracts.TestHistoryQuery): Promise<TCMContracts.TestHistoryQuery> {
        let tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.queryTestHistory(filter);
    }

    public getTestRunById(pageContext: IVssPageContext, runId: number): Promise<TCMContracts.TestRun> {
        if (this._testRun != null) {
            return Promise.resolve(this._testRun);
        }
        let tcmService = pageContext.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.getTestRunById(runId, true);
    }

    public getBranchList(pageContext: IVssPageContext, projectName: string, testCaseResult: TCMContracts.TestCaseResult): Promise<IItem[]> {
        let buildId: number;
        let build: TCMContracts.ShallowReference;
        build = testCaseResult.build;
        if (!build) {
            return Promise.resolve([]);
        }
        buildId = parseInt(build.id);

        let buildRestClient = pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");

        return new Promise<IItem[]>(async (resolve, reject) => {
            let build: BuildContracts.Build = await buildRestClient.getBuild(projectName, buildId);
            try {
                let repoType: string = build.repository.type.toLowerCase();
                if (repoType === RepositoryTypes.TfsGit) {
                    let repoId: string = build.repository.id;
                    let gitService = pageContext.getRestClient<IGitRestClient>("IGitRestClient");
                    let refs = await gitService.getRefs(repoId);
                    resolve(<IItem[]>refs.filter((ref: VCContracts.GitRef) => {
                        return !Utils_String.caseInsensitiveContains(ref.name, "refs/pull");
                    }).map((ref: VCContracts.GitRef) => {
                        return <IItem>{
                            name: ref.name
                        };
                    }));
                }
                else if (repoType == RepositoryTypes.TfsVersionControl) {
                    let tfvcService = pageContext.getRestClient<ITfvcRestClient>("ITfvcRestClient");
                    let branches = await tfvcService.getBranches(build.project.name);
                    resolve(<IItem[]>branches.map((branch: VCContracts.TfvcBranch) => {
                        return <IItem>{
                            name: branch.path
                        };
                    }))
                }
                else {
                    console.error(Utils_String.format("Unsupported repository type. RepositoryType: {0}", build.repository.type));
                    return Promise.resolve([]);
                }
            }
            catch (error) {
                reject(error);
            }
        });
    }

    private _testRun: TCMContracts.TestRun | null;
}
